"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var antd_1 = require("antd");
var ToolBarButtonsOnly_1 = require("../../../../../../../shared/components/toolbars/ToolBarButtonsOnly");
var ToolBarDateRangeFilter_1 = require("../../../../../../../shared/components/toolbars/ToolBarDateRangeFilter");
var JackpotTransferHistoryList = /** @class */ (function (_super) {
    __extends(JackpotTransferHistoryList, _super);
    function JackpotTransferHistoryList(props) {
        var _this = _super.call(this, props) || this;
        _this.columns = [
            {
                title: 'Дата',
                dataIndex: _this.props.data.dk_date_added,
                key: _this.props.data.dk_date_added,
                render: function (text, record, idx) {
                    return (React.createElement("div", null, record.date_added.format(_this.state.dtFormat)));
                },
                width: 200,
            }, {
                title: 'Джекпот',
                dataIndex: _this.props.data.dk_bonus_jackpot_title,
                key: _this.props.data.dk_bonus_jackpot_title,
                width: 150,
            }, {
                title: 'Операция',
                dataIndex: _this.props.data.dk_transfer_type_title,
                key: _this.props.data.dk_transfer_type_title,
                width: 150,
            }, {
                title: 'Сумма',
                dataIndex: _this.props.data.dk_transfer_amount,
                key: _this.props.data.dk_transfer_amount,
                width: 150,
            }, {
                title: 'Баланс до (M/V)',
                dataIndex: _this.props.data.dk_money_balance_before,
                key: _this.props.data.dk_money_balance_before,
                width: 200,
                render: function (text, record, idx) {
                    return (React.createElement("div", null,
                        record.money_balance_before.toFixed(2),
                        "/",
                        record.view_balance_before.toFixed(2)));
                }
            }, {
                title: 'Баланс после (M/V)',
                dataIndex: _this.props.data.dk_money_balance_after,
                key: _this.props.data.dk_money_balance_after,
                width: 200,
                render: function (text, record, idx) {
                    return (React.createElement("div", null,
                        record.money_balance_after.toFixed(2),
                        "/",
                        record.view_balance_after.toFixed(2)));
                }
            }, {
                title: 'Описание',
                dataIndex: _this.props.data.dk_description,
                key: _this.props.data.dk_description,
                width: 200,
            }, {
                title: 'Администратор',
                dataIndex: _this.props.data.dk_act_by_usr_admin_login,
                key: _this.props.data.dk_act_by_usr_admin_login,
                width: 150,
            }
        ];
        return _this;
    }
    JackpotTransferHistoryList.prototype.componentWillMount = function () {
        var _this = this;
        this.SID = this.props.data.Subscribe("*", function (id, data) {
            _this.setState({
                data: data.data,
                totalRows: data.total
            });
        });
        this.SID_STATE = this.props.state.Subscribe("*", function (id, data) {
            _this.setState({
                dtFrom: data.dtFrom,
                dtTo: data.dtTo,
                dtFormat: data.dtTimeFormat
            }, function () {
                _this.loadData(_this.props);
            });
        });
        this.setState({
            data: this.props.data.DATA.data,
            totalRows: 0,
            dtFrom: this.props.state.getDateFrom(),
            dtTo: this.props.state.getDateTo(),
            dtFormat: this.props.state.getDateTimeFormat()
        }, function () {
            _this.loadData(_this.props);
            _this.props.state.setExtBreadCrumbPath(["\u0424\u0438\u043D\u0430\u043D\u0441\u043E\u0432\u044B\u0435 \u043E\u043F\u0435\u0440\u0430\u0446\u0438\u0438 \u0434\u0436\u0435\u043A\u043F\u043E\u0442\u0430 - [" + _this.props.record.title + "]"]);
        });
    };
    JackpotTransferHistoryList.prototype.componentWillUnmount = function () {
        this.props.data.UnSubscribe(this.SID);
        this.props.state.UnSubscribe(this.SID_STATE);
    };
    JackpotTransferHistoryList.prototype.loadData = function (Props, onDone) {
        Props.data.LoadData({
            jackpotId: this.props.record.key,
            from_year: this.state.dtFrom.get('year'),
            from_month: this.state.dtFrom.get('month') + 1,
            from_day: this.state.dtFrom.get('date'),
            from_hour: this.state.dtFrom.get('hour'),
            from_minute: this.state.dtFrom.get('minute'),
            to_year: this.state.dtTo.get('year'),
            to_month: this.state.dtTo.get('month') + 1,
            to_day: this.state.dtTo.get('date'),
            to_hour: this.state.dtTo.get('hour'),
            to_minute: this.state.dtTo.get('minute'),
        }, function () {
            if (onDone) {
                onDone();
            }
        });
    };
    JackpotTransferHistoryList.prototype.onToolBarClick = function (action) {
        if (action === "refresh") {
            this.loadData(this.props);
        }
        if (action === "back") {
            if (this.props.onGoBackClick) {
                this.props.onGoBackClick();
            }
        }
        if (action === "create") {
            if (this.props.onCreateClick) {
                this.props.onCreateClick(this.props.record);
            }
        }
    };
    JackpotTransferHistoryList.prototype.onSelectRange = function (DtFrom, DtTo) {
        this.props.state.setDateFrom(DtFrom).setDateTo(DtTo, true);
    };
    JackpotTransferHistoryList.prototype.render = function () {
        var _this = this;
        return (React.createElement("div", null,
            React.createElement(ToolBarButtonsOnly_1.default, { hint: { refresh: "Обновить", back: "Назад", create: "Создать" }, onClick: this.onToolBarClick.bind(this) },
                React.createElement(ToolBarDateRangeFilter_1.default, { title: "\u0414\u0438\u0430\u043F\u0430\u0437\u043E\u043D \u0434\u0430\u0442: ", from: { date: this.state.dtFrom, title: "Начало" }, to: { date: this.state.dtTo, title: "Окончание" }, onClick: this.onSelectRange.bind(this) })),
            React.createElement(antd_1.Table, { locale: {
                    filterTitle: 'Поиск',
                    filterConfirm: 'Да',
                    filterReset: 'Сброс',
                    emptyText: 'Нет данных',
                }, bordered: true, columns: this.columns, dataSource: this.state.data, pagination: {
                    pageSize: this.props.state.getTablePageSize(),
                    showSizeChanger: true,
                    total: this.state.totalRows,
                    position: "bottom",
                    pageSizeOptions: this.props.state.UITablePageSizeOptions,
                    showQuickJumper: true,
                }, footer: function (data) {
                    return React.createElement("div", null,
                        "\u041E\u0442\u043E\u0431\u0440\u0430\u0436\u0430\u0435\u0442\u0441\u044F \u043D\u0430 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0435 : ",
                        data.length,
                        " \u0438\u0437 ",
                        _this.state.totalRows,
                        " \u0437\u0430\u043F\u0438\u0441\u0435\u0439");
                }, expandedRowRender: function (record) {
                    return (React.createElement("div", null,
                        React.createElement("div", null,
                            React.createElement("b", null, "\u0418\u0434\u0435\u043D\u0442\u0438\u0444\u0438\u043A\u0430\u0442\u043E\u0440 \u0437\u0430\u043F\u0438\u0441\u0438:"),
                            " [",
                            record.key,
                            "] "),
                        React.createElement("div", null,
                            React.createElement("b", null, "\u0421\u043E\u0437\u0434\u0430\u043D:"),
                            " [",
                            record.date_added.format(_this.state.dtFormat),
                            "] "),
                        React.createElement("div", null,
                            React.createElement("b", null, "\u0411\u0430\u043B\u0430\u043D\u0441 \u0434\u043E (money):"),
                            " [",
                            record.money_balance_before,
                            "]"),
                        React.createElement("div", null,
                            React.createElement("b", null, "\u0411\u0430\u043B\u0430\u043D\u0441 \u0434\u043E (view):"),
                            " [",
                            record.view_balance_before,
                            "]"),
                        React.createElement("div", null,
                            React.createElement("b", null, "\u0411\u0430\u043B\u0430\u043D\u0441 \u043F\u043E\u0441\u043B\u0435 (money):"),
                            " [",
                            record.money_balance_after,
                            "]"),
                        React.createElement("div", null,
                            React.createElement("b", null, "\u0411\u0430\u043B\u0430\u043D\u0441 \u043F\u043E\u0441\u043B\u0435 (view):"),
                            " [",
                            record.view_balance_after,
                            "]")));
                }, scroll: { x: true } })));
    };
    return JackpotTransferHistoryList;
}(React.Component));
exports.default = JackpotTransferHistoryList;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/gift_jackpots/ui/component/transfer_history/JackpotTransferHistoryList.tsx
// module id = 2348
// module chunks = 0